import { QuadroSocioPjDTO } from "src/app/sitfis/model/quadro-socio-pj-dto";

export const QUADRO_SOCIO_PJ_DTO: QuadroSocioPjDTO[] = [
  {
    "niSocioAdministrador": "05519039000133",
    "nomeSocioAdministrador": "KXMVQMHMVWD KWXGVKCXGK-HTFXIV BPOC",
    "tipoSocio": "1",
    "qualificacaoSocio": "SOCIO PESSOA JURIDICA DOMICILIADO NO EXTERIOR",
    "participacaoCapitalSocial": 0.01,
    "participacaoCapitalVotante": 0.0,
    "qualificacaoRepresentante": "PROCURADOR",
    "cpfRepresentante": "85122220425",
    "codigoPais": 23,
    "nomePais": "",
    "codigoSituacaoCadastral": 2,
    "situacaoCadastral": "ATIVA",
    "dataSituacaoCadastral": null,
    "codigoBaixaSocio": "00"
  },
  {
    "niSocioAdministrador": "10559850000188",
    "nomeSocioAdministrador": "KXMVQMHMVWD BDXOWD CXDNQMB MHVCHIDWMNU O.E.",
    "tipoSocio": "1",
    "qualificacaoSocio": "SOCIO PESSOA JURIDICA DOMICILIADO NO EXTERIOR",
    "participacaoCapitalSocial": 99.99,
    "participacaoCapitalVotante": 0.0,
    "qualificacaoRepresentante": "PROCURADOR",
    "cpfRepresentante": "85122220425",
    "codigoPais": 573,
    "nomePais": "",
    "codigoSituacaoCadastral": 2,
    "situacaoCadastral": "ATIVA",
    "dataSituacaoCadastral": null,
    "codigoBaixaSocio": "00"
  },
  {
    "niSocioAdministrador": "85122220425",
    "nomeSocioAdministrador": "HVITRL XZIOLH ILXSZ",
    "tipoSocio": "2",
    "qualificacaoSocio": "ADMINISTRADOR",
    "participacaoCapitalSocial": 0.0,
    "participacaoCapitalVotante": 0.0,
    "qualificacaoRepresentante": "",
    "cpfRepresentante": "",
    "codigoPais": 0,
    "nomePais": "",
    "codigoSituacaoCadastral": 0,
    "situacaoCadastral": "REGULAR",
    "dataSituacaoCadastral": null,
    "codigoBaixaSocio": "00"
  },
  {
    "niSocioAdministrador": "25409791819",
    "nomeSocioAdministrador": "",
    "tipoSocio": "2",
    "qualificacaoSocio": "ADMINISTRADOR",
    "participacaoCapitalSocial": 0.0,
    "participacaoCapitalVotante": 0.0,
    "qualificacaoRepresentante": "",
    "cpfRepresentante": "",
    "codigoPais": 0,
    "nomePais": "",
    "codigoSituacaoCadastral": 11,
    "situacaoCadastral": "NAO EXISTENTE NO CADASTRO",
    "dataSituacaoCadastral": null,
    "codigoBaixaSocio": "00"
  }
];